<template>
  <div class="review">
    <div class="review__box">
      <header class="review__box__header">
        <div class="review__box__header__title">
          {{ $t('review.title') }}
          <span
            class="backoffice-icons review__box__header__title__icon"
            v-tooltip="{
              placement: 'top',
              trigger: 'hover click',
              content: $t('review.tooltip'),
              offset: 3,
            }"
          >
            info
          </span>
        </div>
        <div class="review__box__header__toggle">
          <ui-switch id="review-toggle" v-model="isHtml" :reverse="true">
            {{ $t('review.toggle') }}
          </ui-switch>
        </div>
      </header>
      <div class="review__box__container">
        <div class="review__box__container__no-data" v-if="!currentUseCase">
          {{ $t('noData.noUseCase') }}
        </div>
        <template v-else>
          <div class="review__box__container__comment" v-if="!isHtml">
            {{ currentUseCase.comment.text[$i18n.locale] || currentUseCase.comment.text.default }}
          </div>
          <div
            class="review__box__container__comment"
            v-else
            v-html="currentUseCase.comment.html[$i18n.locale] || currentUseCase.comment.html.default"
          ></div>
          <div class="review__box__container__cta">
            <ui-button
              class="review__box__container__cta__button"
              button="cta"
              variant="cta"
              :label="$t('review.cta')"
              @click="generateResponses"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import UiSwitch from '@/components/UI/Switch.vue'
import UiButton from '@/components/UI/Button.vue'
const dayjs = require('dayjs')

export default {
  name: 'Review',
  components: {
    UiSwitch,
    UiButton,
  },
  data() {
    return {
      isHtml: false,
    }
  },
  computed: {
    ...mapState({
      currentUseCase: state => state.data.currentUseCase,
      currentRegistre: state => state.refine.currentRegistre,
      currentSignature: state => state.refine.currentSignature,
      currentPromotion: state => state.refine.currentPromotion,
      currentPromotionDateRange: state => state.refine.currentPromotionDateRange,
      isSignatureActive: state => state.refine.isSignatureActive,
      isPromotionActive: state => state.refine.isPromotionActive,
      locale: state => state.bot.locale,
    }),
  },
  methods: {
    ...mapActions({
      toggleRefreshData: 'bot/toggleRefreshData',
      getBotResponses: 'data/getBotResponses',
    }),
    generateResponses() {
      this.toggleRefreshData(true)
      let urlParams = `&locale=${this.locale}&language_register=${this.currentRegistre.key}`
      urlParams += this.isSignatureActive ? `&footer=${this.currentSignature}` : ''
      urlParams += this.isPromotionActive
        ? `&promotion=${this.currentPromotion}&promotion_from=${dayjs(this.currentPromotionDateRange.start).format(
            'YYYY-MM-DD'
          )}&promotion_to=${dayjs(this.currentPromotionDateRange.end).format('YYYY-MM-DD')}`
        : ''
      this.getBotResponses({ currentUseCase: this.currentUseCase, urlParams }).then(() => {
        this.toggleRefreshData(false)
      })
    },
  },
}
</script>

<style lang="scss">
.review {
  width: 100%;

  @media (min-width: $screen-sm) {
    height: calc(50% - #{$gutter-md / 2});
  }

  &__box {
    @include box;

    @media (min-width: $screen-sm) {
      height: 100%;
    }

    &__header {
      @include header;

      justify-content: space-between;
      padding-right: $gutter-md;

      &__close {
        @include close;
      }

      &__title {
        @include title;

        display: flex;
        align-items: center;

        &__icon {
          margin-left: 12px;
        }
      }

      &__toggle {
        display: flex;
        align-items: center;

        &__icon-left {
          margin-right: 12px;
        }

        &__icon-right {
          margin-left: 12px;
        }
      }
    }

    &__container {
      @include container;

      &__no-data {
        @include noData;
      }

      &__comment {
        @include input;

        height: calc(100% - #{$button-min-height-desktop} - #{$gutter-md});

        .positive,
        .negative,
        .neutral,
        .blacklist {
          font-weight: bold;
        }

        .positive {
          color: #059347;
        }

        .negative {
          color: #a00;
        }

        .neutral {
          color: #e69509;
        }

        .blacklist {
          color: #565656;
        }
      }

      &__cta {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: $spacing-sm;
      }
    }
  }
}
</style>
